import ICommonTextInput from './ICommonTextInput';
import ICommonText from './ICommonText';
import Api from '../../shared/Api';

class CommonTextsApi {
    static create(input: ICommonTextInput): Promise<ICommonText> {
        return new Api().post('/views/commontexts', input);
    }

    static list(): any {
        return new Api().get('/views/commontexts');
    }

    static delete(id: number): any {
        return new Api().delete(`/views/commontexts/${id}`);
    }
}

export default CommonTextsApi;
